import { useAppSelector } from "./redux";

export default function useUserInfo() {
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  return { userInfo };
}

export const useUserColor = () => {
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const growthColor = userInfo?.bizCountry === "china" ? "bg-error" : "bg-success";
  const decreaseColor = userInfo?.bizCountry === "china" ? "bg-success" : "bg-error";

  return { growthColor, decreaseColor };
};
